import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// Importing images
import mercedesV250Image from "../../images/slide-7.jpg";
import EQE from "../../images/EQE.jpg";
import tesla_model_y from "../../images/slide-6.jpg";
import tesla_model_3 from "../../images/tesla_model_3.jpg";
import lexus from "../../images/slide-1.jpg";
import teramount from "../../images/teramount.webp";
import "./Carousel.css";
const Carousel = () => {
  const images = [
    { src: mercedesV250Image, text: "Mercedes V Class" },
    { src: EQE, text: "Mercedes Benz EQE" },
    { src: tesla_model_y, text: "Tesla Model Y" },
    { src: tesla_model_3, text: "Tesla Model 3" },
    { src: lexus, text: "Lexus ES 300H" },
    { src: teramount, text: "Volkswagen Teramont" },
  ];

  // Automatically change slide every 2 seconds

  return (
    <OwlCarousel
      className="owl-theme"
      loop={true}
      autoplay={true}
      margin={15}
      dots={false}
      items={4}
      responsiveClass={true}
      nav={false}
      responsive={{
        0: {
          items: 1,
        },
        600: {
          items: 2,
          nav: false,
        },
        1000: {
          items: 4,
          nav: false,
          loop: true,
        },
      }}
    >
      {images.map((image, index) => (
        <div className="item" key={index}>
          <img src={image.src} alt={image.text} />
          <h4>{image.text}</h4>
        </div>
      ))}
    </OwlCarousel>
  );
};

export default Carousel;
